/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-19 16:07:17
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-26 15:10:34
 * @FilePath: /wemeet-web-activity/src/components/Advertise/index.tsx
 * @Description: 广告浮动窗
 *
 * TODO: 接口联调
 */
import { memo, useCallback, useEffect, useState } from 'react';
// import testPng from './testImage/1.png';
import PublicAdvertingConfig, {
  PublicAdvertisingConfigRes,
} from '@quickService/PublicAdvertisingConfig';
// import getImageBuCosId from '@model/get-image-by-cosid';
import { getCosUrl } from 'src/utils/upload-cos';
import './index.scss';

const Advertise = () => {
  const [imgUrl, setImgUrl] = useState('');
  const [targetUrl, setTargetUrl] = useState('');
  const close = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    setImgUrl('');
  }, []);

  useEffect(() => {
    PublicAdvertingConfig({
      keys: ['LowerRight'],
    }).then((res: PublicAdvertisingConfigRes) => {
      if (res.data) {
        const configOne = res.data?.config_list?.find?.((item) => item.key === 'LowerRight');
        const nTime = Date.now() / 1000;
        if (
          (configOne?.start_time || 0) < nTime &&
          nTime < (configOne?.end_time || 0) &&
          configOne?.cover_id
        ) {
          // 在时间范围内，可以显示
          getCosUrl(configOne.cover_id, '2').then((imgRes) => {
            if (imgRes) {
              const img = new Image();
              img.onload = () => {
                setImgUrl(imgRes);
                setTargetUrl(configOne.link);
              };
              img.src = imgRes;
            }
          });
        }
      }
    });
  }, []);

  if (!imgUrl) {
    return null;
  }

  return (
    <div className="event-advertise">
      <a href={targetUrl} target="_blank" className="event-advertise-zone" rel="noreferrer">
        <img src={imgUrl} className="event-advertise-img" />
        <div className="event-advertise-btn" onClick={close}>
          <i className="iconfont icon-ic_guanbi" />
        </div>
      </a>
    </div>
  );
};

export default memo(Advertise);
